var _a, _b;
import { UrlMappingsKeys } from '../url-mappings-keys';
import { mainMappingVariable } from '../../main-mapping-pattern';
export var postMapping = (_a = {},
    _a[UrlMappingsKeys.BLOG_POST] = {
        variables: ['slug'],
        required: ['slug'],
        subMappings: (_b = {},
            _b[UrlMappingsKeys.BLOG_POST_EDIT] = {
                defaultMapping: "".concat(mainMappingVariable, "/edit"),
            },
            _b[UrlMappingsKeys.BLOG_POST_PREVIEW] = {
                required: ['instance'],
                defaultMapping: "".concat(mainMappingVariable, "/preview/{{instance}}"),
            },
            _b),
    },
    _a);
//# sourceMappingURL=post.js.map